module.exports = __webpack_public_path__ + "img/informatica-01.0ded7d6a.jpg";